import React from 'react';
import { Text, StyleSheet, Image } from 'react-native';

import { useConsumerStatusSummaryQuery } from 'apollo/queries/autogenerate/hooks';
import { isPlusUser } from 'shared/consumer/utils/consumer-types';
import Button from 'shared/modules/common/components/atoms/Button';
import Dialog from 'shared/modules/common/components/atoms/Dialog';
import Shoplist from 'web/assets/images/shoplist.png';

type Props = {
  open: boolean;
  onCloseButtonPress: () => void;
  onEKYCButtonPress: () => void;
};

const styles = StyleSheet.create({
  dialog: {
    maxWidth: 424,
  },
  title: {
    fontSize: 20,
    lineHeight: 24,
    fontWeight: '600',
    marginBottom: 24,
  },
  body: {
    fontSize: 16,
    lineHeight: 24,
    fontWeight: '300',
  },
  button: {
    alignSelf: 'center',
    fontSize: 16,
    lineHeight: 24,
    fontWeight: '600',
    height: 48,
    width: 264,
  },
  note: {
    fontSize: 14,
    lineHeight: 24,
    fontWeight: '300',
    marginTop: 24,
    marginBottom: 24,
  },
  banner: {
    width: 376,
    height: 140,
    resizeMode: 'contain',
    alignSelf: 'center',
    marginBottom: 32,
  },
});

const ShoplistAnnouncementDialog = ({
  open,
  onCloseButtonPress,
  onEKYCButtonPress,
}: Props) => {
  const { data } = useConsumerStatusSummaryQuery();
  const houkatsuStatus = data?.houkatsuStatus?.status;
  const kycStatus = data?.KYCApplicationStatus?.status;
  const isPlus = isPlusUser(kycStatus, houkatsuStatus);

  if (open === false) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onCloseButtonPress={onCloseButtonPress}
      style={[styles.dialog, { maxHeight: !isPlus ? 660 : 636 }]}
      title=""
      id="cvs-fee-increase-dialog"
    >
      <Image source={{ uri: Shoplist }} style={styles.banner} />
      <Text
        style={styles.title}
      >{`SHOPLIST「超あと払い」サービス終了のお知らせ`}</Text>
      <Text style={styles.body}>
        SHOPLISTでご利用いただいていた「超あと払い」は、{' '}
        <span style={{ fontWeight: 'bold' }}>2023年12月20日（水）</span>
        23:59をもちまして、サービスを終了させていただきます。
      </Text>
      {!isPlus ? (
        <>
          <Text style={styles.body}>
            今後は、{' '}
            <span style={{ fontWeight: 'bold' }}>
              分割手数料無料*の3・6回あと払い
            </span>
            をご利用ください。お支払い総額はそのまま、分割手数料無料*でお支払いを3回または6回に分けることができます。ペイディアプリから本人確認後、ご利用いただけます。
          </Text>
          <Text style={styles.note}>*口座振替・銀行振込のみ無料</Text>
          <Button
            title="今すぐ本人確認する"
            variant="primary"
            onPress={onEKYCButtonPress}
            style={styles.button}
          />
        </>
      ) : (
        <>
          <Text style={styles.body}>
            今後は、{' '}
            <span style={{ fontWeight: 'bold' }}>
              分割手数料無料*の3・6回あと払い
            </span>
            をご利用ください。お支払い総額はそのまま、分割手数料無料*でお支払いを3回または6回に分けることができます。
          </Text>
          <Text style={styles.note}>*口座振替・銀行振込のみ無料</Text>
          <Button
            title="閉じる"
            variant="primary"
            style={styles.button}
            onPress={onCloseButtonPress}
          />
        </>
      )}
    </Dialog>
  );
};

export default ShoplistAnnouncementDialog;
